export default "__VITE_ASSET__ChMPEQZ0__"